import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksBudgetImpactDetailsPopupContent', {
    title: 'Budget check for "{budgetName}" budget',
    note: 'Please see below line items of <b>"{requestFriendlyName}"</b> that affect the <b>"{budgetName}"</b> budget, <b>"{category}"</b> account for <b>"{period}"</b> period.',
    warningOfExceed: 'Total amount of Bills, Purchase Orders and Expenses exceeds the budget',
    item: 'Item',
    description: 'Description',
    qty: 'Qty',
    rate: 'Rate',
    tax: 'Tax',
    category: 'Category',
    amount: 'Amount ({currency})',
    totalBudgetImpact: 'Total budget impact ({currency})',
});
